import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { routes } from './app/app-routing.module';
import { appConfig } from './app/app.config';

const additionalProviders = [
  importProvidersFrom(BrowserAnimationsModule),
  importProvidersFrom(RouterModule.forRoot(routes)), 
  importProvidersFrom(HttpClientModule),
];

appConfig.providers = [
  ...(appConfig.providers || []),
  ...additionalProviders,
];

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
